import { render } from "./WebPage.vue?vue&type=template&id=7847ead8&scoped=true&lang=pug"
import script from "./WebPage.vue?vue&type=script&lang=js"
export * from "./WebPage.vue?vue&type=script&lang=js"

import "./WebPage.vue?vue&type=style&index=0&id=7847ead8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7847ead8"

export default script